// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "./application";
import { registerControllers } from "stimulus-vite-helpers";
import Dropdown from "@stimulus-components/dropdown";

application.register("dropdown", Dropdown);

// Use glob pattern for importing controllers
const controllers = import.meta.glob("./**/*_controller.js", { eager: true });
registerControllers(application, controllers);
